<template>
  <div>
    <v-card class="pa-1">
      <v-card-text>
        <div class="banner">
          <h4>{{ $t('titles.orgon_in_block') }} ({{ group }})</h4>
        </div> 
      </v-card-text>
      

      <v-card-text>
        <v-form ref="blockForm">
          <v-row dense class="d-flex justify-end">
            <v-col cols="12" sm="4" >
              <v-text-field
                class="rounded-lg "
                color="#086318"
                type="datetime-local"
                outlined
                dense
                :rules="dateRules"
                :max="maxDateForOrgonsCaptation"
                :min="minDateForOrgonsCaptation"
                v-model="form.captation_hour"
              >
                <template v-slot:label>
                  {{ $t('inputs.captations.captation_hour') }}<span style="color: red">*</span>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12" sm="2">
              <v-select
                class="rounded-lg"
                color="#086318"
                v-model="form.biopsy"
                :items="yesorNot"
                :rules="isRim ? formRules : []"
                item-text="name"
                item-value="value"
                dense
                outlined
              >
                <template v-slot:label>
                  {{ $t('inputs.captations.biopsy') }}
                  <span style="color: red">{{ isRim ? '*' : '' }}</span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="3">
              <v-select
                class="rounded-lg"
                color="#086318"
                v-model="form.packed"
                :items="yesorNot"
                :rules="formRules"
                item-text="name"
                item-value="value"
                dense
                outlined
              >
                <template v-slot:label>
                  {{ $t('inputs.captations.packed') }}
                  <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="2">
              <v-select
                class="rounded-lg"
                color="#086318"
                v-model="form.preservation_solutions_id"
                :items="solucoes"
                :rules="formRules"
                item-text="name"
                item-value="id"
                dense
                outlined
              >
                <template v-slot:label>
                  {{ $t('inputs.captations.preservation_solutions') }} <span style="color: red">*</span>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" sm="2">
              <v-text-field
                class="rounded-lg"
                color="#086318"
                outlined
                dense
                v-model="form.number_lot"
                :label="$t('inputs.captations.number_lot')"
              />
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                class="rounded-lg"
                color="#086318"
                outlined
                dense
                type="date"
                :max="maxDateToLoteValidation"
                v-model="form.lot_expiration_date"
                :label="$t('inputs.captations.lot_expiration_date')"
              />
            </v-col>
          </v-row>

          <v-row dense v-if="isRim">
            <v-col cols="12" v-for="side in kidneyNephrectomies" :key="side.key">
              <v-card outlined class="pa-4 rounded-lg mb-3">
                <h4 class="mb-3">
                  <v-icon small color="#41916b">mdi-hospital</v-icon>{{ $t('inputs.captations.nephrectomy') }} - {{ side.label }}:
                </h4>
                <v-row>
                  <v-col cols="12" sm="2">
                    <v-radio-group :rules="formRules" v-model="form[side.key].normal_morphology">
                      <p>{{ $t('inputs.captations.normal_morphology') }}<span style="color: red">*</span></p>
                      <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
                      <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-radio-group :rules="formRules" v-model="form[side.key].single_arterial_pedicle">
                      <p>{{ $t('inputs.captations.single_arterial_pedicle') }} <br />{{ $t('inputs.captations.unic') }}<span style="color: red">*</span></p>
                      <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
                      <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-radio-group :rules="formRules" v-model="form[side.key].single_venous_pedicle">
                      <p>{{ $t('inputs.captations.single_venous_pedicle') }} <br />{{ $t('inputs.captations.unic') }}<span style="color: red">*</span></p>
                      <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
                      <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="2">
                    <v-radio-group :rules="formRules" v-model="form[side.key].single_ureteral_rout">
                      <p>{{ $t('inputs.captations.single_ureteral_rout') }} Única?<span style="color: red">*</span></p>
                      <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
                      <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <v-col cols="12" sm="2">
                    <v-radio-group :rules="formRules" v-model="form[side.key].adequate_perfusion">
                      <p>{{ $t('inputs.captations.adequate_perfusion') }}<span style="color: red">*</span></p>
                      <v-radio :label="$t('options.yes')" value="SIM" color="#086318"></v-radio>
                      <v-radio :label="$t('options.not')" value="NÃO" color="#086318"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn dark color="#89ab9b" class="rounded-lg" @click="clear">{{$t('buttons.clean_up')}}</v-btn>
          <v-spacer />
        <v-btn text @click="$emit('cancel')">{{$t('buttons.cancel')}}</v-btn>
        <v-btn color="#41916b" dark class="rounded-lg" @click="save">{{$t('buttons.save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { getPreservationSolutions } from "@/service/CaptationFieldsService";

export default {
  props: {
    group: { type: String, default: null },
    dateRules: { type: Array, default: () => [] },
    maxDateForOrgonsCaptation: { type: String, default: null },
    minDateForOrgonsCaptation: { type: String, default: null },
  },

  data() {
    return {
      solucoes: [],
      yesorNot: [
        { name: "Sim", value: "1" },
        { name: "Não", value: "2" },
      ],
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      form: {
        captation_hour: null,
        biopsy: null,
        packed: null,
        preservation_solutions_id: null,
        number_lot: null,
        lot_expiration_date: null,
        nephrectomy_left: {
          normal_morphology: null,
          single_arterial_pedicle: null,
          single_venous_pedicle: null,
          single_ureteral_rout: null,
          adequate_perfusion: null,
        },
        nephrectomy_right: {
          normal_morphology: null,
          single_arterial_pedicle: null,
          single_venous_pedicle: null,
          single_ureteral_rout: null,
          adequate_perfusion: null,
        }
      }
    };
  },

  async created() {
    this.solucoes = await getPreservationSolutions();
  },

  computed: {
    isRim() {
      return this.group === 'rim';
    },

    kidneyNephrectomies() {
      return [
        { key: 'nephrectomy_left',  label: 'RIM ESQUERDO' },
        { key: 'nephrectomy_right', label: 'RIM DIREITO'  },
      ];
    },

    maxDateToLoteValidation() {
      return new Date('2060-01-01').toISOString().slice(0, 10);
    }
  },

  methods: {
    save() {
      if (!this.$refs.blockForm.validate()) return;
      this.$emit('save', { ...this.form })
      this.clear();
      this.$emit('cancel')
    },

    clear() {
      const emptyNephrectomy = () => ({
        normal_morphology: null,
        single_arterial_pedicle: null,
        single_venous_pedicle: null,
        single_ureteral_rout: null,
        adequate_perfusion: null,
      });

      this.form = {
        captation_hour: null,
        biopsy: null,
        packed: null,
        preservation_solutions_id: null,
        number_lot: null,
        lot_expiration_date: null,
        nephrectomy_left: emptyNephrectomy(),
        nephrectomy_right: emptyNephrectomy(),
      };
      this.$refs.blockForm.resetValidation();
    }
  }
};
</script>
<style scoped>
.textBTN {
  color: white;
  font-weight: 500;
}

.banner {
  background: #b3ffab; 
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c); 
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd); 

  border-radius: 8px;  
  display: flex;
  align-items: center; 
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
